import { render, staticRenderFns } from "./CompainCard.vue?vue&type=template&id=49426774&scoped=true"
import script from "./CompainCard.vue?vue&type=script&lang=js"
export * from "./CompainCard.vue?vue&type=script&lang=js"
import style0 from "./CompainCard.vue?vue&type=style&index=0&id=49426774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49426774",
  null
  
)

export default component.exports